import { PropsWithChildren } from "react";
import clsx from "clsx";
import * as Accordion from "@radix-ui/react-accordion";
import { InsightsSummaryAccordionItem } from "./InsightsSummaryAccordionItem";

type InsightSummaryAccordionProps = PropsWithChildren<
  Pick<Accordion.AccordionSingleProps, "onValueChange" | "value">
> & { className?: string };

export function InsightsSummaryAccordion({ className, children, ...props }: InsightSummaryAccordionProps) {
  const quickInsightCols = localStorage.getItem("quickInsightCols") === "true";
  return (
    <Accordion.Root
      {...props}
      data-testid="insights-accordion"
      type="single"
      collapsible
      className={clsx(
        "grid gap-2 m-2 mb-4 print:break-inside-avoid",
        quickInsightCols && window.location.href.indexOf("site-report") === -1 ? "grid-cols-2" : "grid-cols-1",
        className
      )}
    >
      {children}
    </Accordion.Root>
  );
}

InsightsSummaryAccordion.Item = InsightsSummaryAccordionItem;
